import { FC, Fragment } from 'react';
import { GuestsCard } from 'entities/toolbar/guests/ui/components/GuestCard';
import { GuestsTime, GuestsTitle } from '../styles';
import { Order } from 'entities/orders';
import { useAppSelector } from 'shared/lib/store';
import { selectOrdersSearchNext } from 'entities/orders/model/selectors';
import { borderRadius } from 'entities/toolbar/guests/ui/types/components';

type Props = {
    select?: (selectedId: number) => void;
    orders: {
        time: string;
        ordersList: Order[];
    }[];
    isEmpty: boolean;
}

export const GuestsWaitingNext: FC<Props> = ({ select, orders, isEmpty }) => {
    const ordersSearch = useAppSelector(selectOrdersSearchNext);

    const count = orders.reduce((count, group) => count + group.ordersList.length, 0);
    const persons = orders.reduce((count, group) => count + group.ordersList?.reduce((orderPersons, order) => orderPersons + order.participants_count, 0), 0);

    const hasSearchRequest = Boolean(ordersSearch.trim());

    if (isEmpty) {
        return null;
    }


    return (
        <>
            {!hasSearchRequest && <GuestsTitle $variant="main" className='guests-title'>Ожидаются {count}/{persons}</GuestsTitle>}
            {orders?.filter(timeGroup => timeGroup.ordersList?.length).map(timeGroup => {
                return (
                    <Fragment key={timeGroup.time}>
                        {!hasSearchRequest && <GuestsTime $variant="main" className='guests-time'>{timeGroup.time}</GuestsTime>}
                        {timeGroup.ordersList.map((order, index) => {
                          const borderRadius = {} as borderRadius;
                          if (index === 0) {
                            borderRadius.topLeft = 12;
                            borderRadius.topRight = 12;
                          }
                          if (index === timeGroup.ordersList.length - 1) {
                            borderRadius.bottomLeft = 12;
                            borderRadius.bottomRight = 12;
                          }
                          return (
                            <GuestsCard id={index === 0 ? `group-${timeGroup.time}` : undefined} key={order.id} select={select} order={order} borderRadius={borderRadius}/>
                          )
                        })}
                    </Fragment>
                )
            })}
        </>
    );
};
